const SENSITIVE_PAYMENT_PREFIX = "/pay";

export function isSensitivePaymentPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return (
    pathname === SENSITIVE_PAYMENT_PREFIX || pathname.startsWith(`${SENSITIVE_PAYMENT_PREFIX}/`)
  );
}

export function isBrowserTelemetrySuppressed(): boolean {
  return typeof window !== "undefined" && isSensitivePaymentPath(window.location.pathname);
}
